"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CompetitionProductInfoForm = _interopRequireDefault(require("./CompetitionProductInfoForm"));
var _competitionProductConfig = require("@/api/priceSetting/priceMonitoring/competitionProductConfig.js");
var _options = require("@/utils/options.js");
var _permission = require("@/utils/permission.js");
var _coverImage = _interopRequireDefault(require("@/assets/images/cover-image.png"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CompetitionProductForm',
  components: {
    CompetitionProductInfoForm: _CompetitionProductInfoForm.default
  },
  data: function data() {
    return {
      coverImage: _coverImage.default,
      // 默认封面图片
      checkPermi: _permission.checkPermi,
      // 权限校验
      productId: null,
      // 商品ID
      skuId: null,
      // 商品skuId
      dialogVisible: false,
      // 是否显示弹框
      dialogTitle: '',
      // 弹框标题
      formType: '',
      // 表单类型：create - 新增 update - 修改
      formLoading: false,
      //  表单加载状态
      tableData: [],
      // 列表数据
      loading: false,
      // 加载状态
      productInfo: {},
      // 商品信息
      platformIdsOptions: _options.platformIdsOptions,
      // 竞品平台
      sourceOptions: _options.sourceOptions,
      // 竞品来源
      findLabelInArray: _options.findLabelInArray // 获取数组中指定值的标签
    };
  },
  methods: {
    // 打开弹框 type： TB - 淘宝配置 JD - 京东配置
    open: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type, productId, skuId) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.dialogVisible = true;
              this.formType = type;
              this.dialogTitle = "\u76D1\u63A7\u5546\u54C1\u7ADE\u54C1\u914D\u7F6E-".concat(type === 'TB' ? '淘宝' : '京东');
              this.productId = productId;
              this.skuId = skuId;
              this.getDetail();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open(_x, _x2, _x3) {
        return _open.apply(this, arguments);
      }
      return open;
    }(),
    // 获取详情
    getDetail: function () {
      var _getDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var data, res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              _context2.p = 1;
              data = {
                productId: this.productId,
                skuId: this.skuId,
                platform: this.formType === 'TB' ? 1 : 2
              };
              _context2.n = 2;
              return (0, _competitionProductConfig.getCompetitorConfigApi)(data);
            case 2:
              res = _context2.v;
              this.productInfo = res || {};
              this.tableData = (res === null || res === void 0 ? void 0 : res.competitorList) || [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              console.log('获取监控商品竞品配置失败', _t);
            case 4:
              _context2.p = 4;
              this.loading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function getDetail() {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    // 处理是否关联的切换
    handleRelatedChange: function handleRelatedChange(row, value) {
      var _this = this;
      this.$modalSure("".concat(row.isAssociated ? '取消关联' : '关联', "\u5F53\u524D\u5546\u54C1\u7ADE\u54C1\u914D\u7F6E\u5417")).then(function () {
        (0, _competitionProductConfig.editCompetitorAssociateApi)({
          id: row.id,
          isAssociated: value
        }).then(function (data) {
          _this.$message.success('操作成功!');
          _this.getDetail();
        });
      });
    },
    // 添加/编辑操作
    openForm: function openForm(type, row) {
      this.$refs.formRef.open(type, this.formType, this.productId, this.skuId, row);
    },
    // 删除
    handlerOpenDel: function handlerOpenDel(id) {
      var _this2 = this;
      this.$modalSure('删除当前商品竞品配置吗').then(function () {
        (0, _competitionProductConfig.deleteCompetitorApi)(id).then(function (data) {
          _this2.$message.success('删除成功!');
          _this2.getDetail();
        });
      });
    },
    // 重置表单
    resetForm: function resetForm() {
      this.tableData = [];
      this.formLoading = false;
      this.$emit('success');
    }
  }
};